export default {
	maman : {
		tableau : [
			{
				libelle : 'Avant la fin du 3<sup>ème</sup> mois',
				haut : {
					libelle : '1<sup>er</sup> examen prénatal',
					dateDebut : {
						nbMois : 0,
						nbJour : 0
					},
					dateFin : {
						nbMois : 3,
						nbJour : -1
					}
				},
				bas : {
					type : 'chip',
					libelle : '1<sup>ère</sup>&nbsp;échographie',
					dateDebut : {
						nbMois : 0,
						nbJour : 56
					},
					dateFin : {
						nbMois : 0,
						nbJour : 82
					}
				}
			},
			{
				libelle : '4<sup>ème</sup> mois',
				haut : {
					libelle : '2<sup>ème</sup> examen prénatal',
					dateDebut : {
						nbMois : 3,
						nbJour : 0
					},
					dateFin : {
						nbMois : 4,
						nbJour : -1
					}
				},
				bas : {
					type : 'text',
					libelle : '1<sup>ère</sup> séance de préparation à la naissance et à la parentalité'
				}
			},
			{
				libelle : '5<sup>ème</sup> mois',
				haut : {
					libelle : '3<sup>ème</sup> examen prénatal',
					dateDebut : {
						nbMois : 4,
						nbJour : 0
					},
					dateFin : {
						nbMois : 5,
						nbJour : -1
					}
				},
				bas : {
					type : 'chip',
					libelle : '2<sup>ème</sup>&nbsp;échographie',
					dateDebut : {
						nbMois : 0,
						nbJour : 119
					},
					dateFin : {
						nbMois : 0,
						nbJour : 160
					}
				}
			},
			{
				libelle : '6<sup>ème</sup> mois',
				haut : {
					libelle : '4<sup>ème</sup> examen prénatal',
					dateDebut : {
						nbMois : 5,
						nbJour : 0
					},
					dateFin : {
						nbMois : 6,
						nbJour : -1
					}
				}
			},
			{
				libelle : '7<sup>ème</sup> mois',
				haut : {
					libelle : '5<sup>ème</sup> examen prénatal',
					dateDebut : {
						nbMois : 6,
						nbJour : 0
					},
					dateFin : {
						nbMois : 7,
						nbJour : -1
					}
				},
				bas : {
					type : 'text',
					libelle : 'Début des 7 séances de préparation à la naissance et à la parentalité'
				}
			},
			{
				libelle : '8<sup>ème</sup> mois',
				haut : {
					libelle : '6<sup>ème</sup> examen prénatal',
					dateDebut : {
						nbMois : 7,
						nbJour : 0
					},
					dateFin : {
						nbMois : 8,
						nbJour : -1
					}
				},
				bas : {
					type : 'chip',
					libelle : '3<sup>ème</sup>&nbsp;échographie',
					dateDebut : {
						nbMois : 0,
						nbJour : 189
					},
					dateFin : {
						nbMois : 0,
						nbJour : 230
					}
				}
			},
			{
				libelle : '9<sup>ème</sup> mois',
				haut : {
					libelle : '7<sup>ème</sup> examen prénatal',
					dateDebut : {
						nbMois : 8,
						nbJour : 0
					},
					dateFin : {
						nbMois : 9,
						nbJour : -1
					}
				}
			},
			{
				libelle : 'Avant la fin du 2<sup>ème</sup> mois suivant la naissance',
				bas : {
					type : 'text',
					libelle : 'Examen des 8 semaines <br>après l\'accouchement',
					dateFin : {
						nbMois : 9,
						nbJour : 56
					}
				},
				dernier: true
			}
		]
	},
	enfant : {
		title : 'Le calendrier de suivi de mon enfant',
		tableau : [
			{
				libelle : 'Dans les 8 jours suivants la naissance',
				bas : {
					type : 'text',
					libelle : 'Examen des 8 jours',
					dateFin : {
						nbMois : 9,
						nbJour : 8
					}
				}
			},
			{
				libelle : '2<sup>ème</sup> semaine',
				bas : {
					type : 'text',
					libelle : 'Examen de la 2<sup>ème</sup> semaine',
					dateDebut : {
						nbMois : 9,
						nbJour : 8
					},
					dateFin : {
						nbMois : 9,
						nbJour : 14
					}
				}
			},
			{
				libelle : '1<sup>er</sup> mois',
				bas : {
					type : 'text',
					libelle : 'Examen du 1<sup>er</sup> mois',
					dateDebut : {
						nbMois : 10,
						nbJour : 0
					},
					dateFin : {
						nbMois : 11,
						nbJour : -1
					}
				},
				dernier: true
			}
		]
	},
	periode : 'Du <span class="font-weight-bold">{dateDebut}</span> au <span class="font-weight-bold">{dateFin}</span>',
	avant : 'Avant le <span class="font-weight-bold">{dateFin}</span>'
}